var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.formModule.component,{key:_vm.key,tag:"component",attrs:{"name":_vm.formModule.name,"reportName":_vm.formModule.reportName}})
}
var staticRenderFns = []

export { render, staticRenderFns }